module.exports = __webpack_public_path__ + "c05f71deac3d749806b1a0c5d6220136.jpg";